import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PwaA2hsService } from './a2hs/pwa-a2hs.service';
import { NPwa } from './pwa.interface';
import { PWA_OPTIONS } from './pwa.options';
import { PwaUpdateService } from './update/pwa-update.service';

/**
 * @example
 *
 * ```typescript
 *   @HostListener('window:offline')
 *   onOffline() {
 *       this.pwaService.applicationOffline();
 *   }
 *
 *   @HostListener('window:online')
 *   onOnline() {
 *       this.pwaService.applicationOnline();
 *   }
 * ```
 */
@Injectable({
    providedIn: 'root'
})
export class PwaService {
    online$: Subject<boolean> = new BehaviorSubject<boolean>(true);

    constructor(
        protected pwaUpdateService: PwaUpdateService,
        protected pwaA2hsService: PwaA2hsService,
        @Inject(PWA_OPTIONS) protected options: NPwa.IModuleOptions
    ) {}

    init(): void {
        if (this.options.enabled) {
            this.pwaUpdateService.init();
            this.pwaA2hsService.init();
        }
    }

    applicationOffline() {
        this.online$.next(false);
    }

    applicationOnline() {
        this.online$.next(true);
    }
}
